import { CallApi, handleJSONResponse, handleResponse } from './common';
import { Roster } from '@services/rosters/types/roster';
import { RosterRelation } from '@services/rosters/types/roster-relation';
import { NewRosterRelation } from '@services/rosters/types/new-roster-relation';
import { RosterOperator } from '@services/rosters/types/roster-operator';

const callAPI = CallApi('rosters');

export const create = async (
  labelId: string,
  name: string
): Promise<Roster> => {
  const response = await callAPI('/', 'POST', { name, labelId });

  return await handleJSONResponse(response);
};

export const list = async (labelId: string): Promise<Roster[]> => {
  const response = await callAPI(`/list/${labelId}`, 'GET');

  return await handleJSONResponse(response);
};

export const listArtists = async (
  rosterId: string,
  labelId: string
): Promise<RosterRelation[]> => {
  const response = await callAPI(`/artists/${rosterId}/${labelId}`, 'GET');

  return await handleJSONResponse(response);
};

export const update = async (roster: Roster): Promise<Roster> => {
  const response = await callAPI('/', 'PUT', roster);

  return await handleJSONResponse(response);
};

export const updateRelation = async (
  rosterRelation: RosterRelation
): Promise<RosterRelation> => {
  const response = await callAPI(
    `/${rosterRelation.id}/${rosterRelation.artistId}`,
    'PUT',
    rosterRelation
  );

  return await handleJSONResponse(response);
};

export const remove = async (
  rosterId: string,
  labelId: string
): Promise<void> => {
  const response = await callAPI(`/remove/${rosterId}/${labelId}`, 'DELETE');

  await handleResponse(response);
};

export const attachRelation = async (
  relation: NewRosterRelation
): Promise<RosterRelation> => {
  const response = await callAPI(
    `/${relation.rosterId}/${relation.artistId}`,
    'POST',
    relation
  );

  return await handleJSONResponse(response);
};

export const removeRosterRelation = async (
  relation: RosterRelation
): Promise<void> => {
  const response = await callAPI(
    `/${relation.id}/${relation.artistId}`,
    'DELETE'
  );

  await handleResponse(response);
};

export const listRosterOperators = async (
  recordLabelId: string
): Promise<RosterOperator[]> => {
  const response = await callAPI(`/${recordLabelId}/operators`, 'GET');

  return await handleJSONResponse(response);
};

export const createRosterOperator = async (
  rosterId: string,
  userName: string,
  userId: string
): Promise<RosterOperator> => {
  const response = await callAPI(`/${rosterId}/operators`, 'POST', {
    rosterId,
    userName,
    userId,
  });

  return await handleJSONResponse(response);
};

export const removeRosterOperator = async (
  rosterId: string,
  operatorId: string
): Promise<void> => {
  const response = await callAPI(
    `/${rosterId}/operators/${operatorId}`,
    'DELETE'
  );

  await handleResponse(response);
};
